import { createContext, useContext, useState, useCallback } from "react";
import { ContactFormDialog } from "@/features/contact/components/ContactFormDialog";

interface ContactFormDialogState {
  openContactForm: () => void;
}

const ContactFormDialogContext = createContext<
  ContactFormDialogState | undefined
>(undefined);

export const ContactFormDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openContactForm = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <ContactFormDialogContext.Provider value={{ openContactForm }}>
      {children}
      <ContactFormDialog open={open} setOpen={setOpen} />
    </ContactFormDialogContext.Provider>
  );
};

export const useContactFormDialog = (): ContactFormDialogState => {
  const context = useContext(ContactFormDialogContext);
  if (context === undefined) {
    throw new Error(
      "useContactFormDialogはContactFormDialogProvider内で使用してください"
    );
  }
  return context;
};
